import { render, staticRenderFns } from "./EventSaveModal.vue?vue&type=template&id=3ff9b9a3&slot=items&"
import script from "./EventSaveModal.script.js?vue&type=script&lang=js&"
export * from "./EventSaveModal.script.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports